<div class="app-header-container">
  <img
    src="../../../../../assets/images/ibc-customer-logo.svg"
    alt="IBC Customer Page Logo" />
  <div class="user-info-section" *ngIf="userDetailsData; else showLogin">
    <div class="user-basic-info">
      <span class="ibc-body-text-large-bold">{{
        userDetailsData.firstName | titlecase
      }}</span>
    </div>
    <span
      [matMenuTriggerFor]="menu"
      class="user-info-avatar ibc-customer-heading-h4-regular"
      >{{ (userDetailsData?.firstName?.[0] || '').toUpperCase() + (userDetailsData?.lastName?.[0] || '').toUpperCase() }}</span
    >
    <mat-menu #menu="matMenu" class="app-header-menu">
      <mat-card class="user-info-card" appearance="outlined">
        <mat-card-header>
          <div mat-card-avatar class="user-avatar">
            <span>{{
              (userDetailsData?.firstName?.[0] || '') +
                (userDetailsData?.lastName?.[0] || '')
            }}</span>
          </div>
          <mat-card-title class="ibc-body-text-large-bold">{{
            userDetailsData.fullName ||
              userDetailsData.firstName + ' ' + userDetailsData.lastName
              | titlecase
          }}</mat-card-title>
        </mat-card-header>
        <mat-card-actions>
          <button mat-button (click)="redirectToUserProfile()">
            My Profile
          </button>
        </mat-card-actions>
        <mat-card-actions>
          <button mat-button (click)="logout()">Logout</button>
        </mat-card-actions>
      </mat-card>
    </mat-menu>
  </div>

  <ng-template #showLogin>
    <button
      mat-button
      class="mat-button-md ibc-primary-default-button"
      (click)="login()">
      Log In
    </button>
  </ng-template>
</div>
